import { render, staticRenderFns } from "./ordinipdf.vue?vue&type=template&id=5c04ace1&scoped=true&lang=html"
import script from "./ordinipdf.vue?vue&type=script&lang=js"
export * from "./ordinipdf.vue?vue&type=script&lang=js"
import style0 from "./ordinipdf.vue?vue&type=style&index=0&id=5c04ace1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c04ace1",
  null
  
)

export default component.exports